import ko from "knockout";
import session from "flow/session/session";
import manifestManager from "flow/utils/manifestManager";
import config from "flow/config";
import viewCache from "flow/utils/viewCache";
import viewHtml from "./LoginDialog.html";
import { CloseCallback, Dictionary } from "flow/api/types";
import bind from "bind-decorator";
import MyFlow from "flow/MyFlow";
import environment from "flow/configuration/environment";
import dataService from "flow/data/service";

manifestManager.addManifests(config.moduleId, [
    {
        id: config.componentIds.loginDialog,
        isDialog: true,
        namespace: "default",
        reuseInstance: false,
        titleClasses: "text-center lc-child-w-100",
        useFormValidation: false,
        viewModelId: "flow/viewModels/LoginDialog",
        viewUrl: "virtual/LoginDialog"
    }
]);

viewCache.inject("virtual/LoginDialog", viewHtml);

export default class LoginDialog {
    private closeCallback: CloseCallback;
    componentTitle = ko.observable<string>();

    constructor(private readonly myFlow: MyFlow) {
        this.componentTitle(this.myFlow.translate("FlowHtml.Translations.ReloginDialogTitle"));
    }

    activate(_viewContext: Dictionary, closeCallback: CloseCallback) {
        this.closeCallback = closeCallback;
        window.addEventListener("message", this.messageListener);
    }

    onDestroy() {
        window.removeEventListener("message", this.messageListener);
    }

    onOpenPage() {
        window.open("LoggedIn");
    }

    logout() {
        this.closeCallback(false);
        session.forceLogout(true);
    }

    @bind
    async messageListener(event: MessageEvent) {
        if (event.origin === window.location.origin && event.data === "relogin_successful") {
            const initialUserId = environment.get<string>(environment.keys.userId);
            const currentUserId = await dataService.whoami(this.myFlow);

            if (currentUserId === initialUserId) {
                this.closeCallback(true);
            } else {
                // User has been switched!
                // Reload all tabs at home screen to reflect accurate information.
                session.forceReloadWithBroadcast();
            }
        }
    }
}
